import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8692 16.8764C15.0062 15.6584 15.7025 14.0107 15.7025 12.2023C15.7025 10.394 15.0062 8.7464 13.8693 7.52838C13.4466 7.64314 13.0472 7.81611 12.6797 8.03838C13.7968 9.05821 14.5025 10.5429 14.5025 12.2023C14.5025 13.8618 13.7968 15.3465 12.6796 16.3664C13.0471 16.5886 13.4465 16.7616 13.8692 16.8764Z"
          fill={color}
        />
        <path
          d="M10.0493 6.71631C9.72581 6.65499 9.39249 6.62295 9.05212 6.62295C6.05382 6.62295 3.60173 9.10892 3.60173 12.2023C3.60173 15.2957 6.05382 17.7817 9.05212 17.7817C9.39244 17.7817 9.72571 17.7497 10.0492 17.6884C10.4102 18.0345 10.8054 18.3438 11.229 18.6106C10.5475 18.851 9.81526 18.9817 9.05212 18.9817C5.36734 18.9817 2.40173 15.9345 2.40173 12.2023C2.40173 8.47017 5.36734 5.42295 9.05212 5.42295C9.81532 5.42295 10.5477 5.55368 11.2292 5.79414C10.8055 6.06088 10.4103 6.37022 10.0493 6.71631Z"
          fill={color}
        />
        <path
          d="M15.0891 18.3818C18.4307 18.3818 21.1395 15.6152 21.1395 12.2024C21.1395 8.78963 18.4307 6.02303 15.0891 6.02303C11.7476 6.02303 9.03876 8.78963 9.03876 12.2024C9.03876 15.6152 11.7476 18.3818 15.0891 18.3818Z"
          stroke={color}
          strokeWidth="1.2"
          strokeMiterlimit="10"
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'connect');
export default IconComponent;
